import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from '../Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  close$default1evna6yun3t5h as close$default,
  SendChannel38sllbxw662ws as SendChannel,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
} from './Channel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelCoroutineClass;
function ChannelCoroutine() {
  if (ChannelCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, _channel, initParentJob, active) {
        super(parentContext, initParentJob, active);
        this.d1c_1 = _channel;
      }
      nx(cause) {
        if (this.ax())
          return Unit_instance;
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().c15(null == null ? this.hw() : null, null, this);
        } else {
          tmp = cause;
        }
        this.px(tmp);
      }
      r1b(cause, $super) {
        return this.ox(cause, ($super == null ? true : $super instanceof ChannelCoroutine()) ? $super : THROW_CCE());
      }
      px(cause) {
        var exception = this.fx(cause);
        this.d1c_1.nx(exception);
        this.sx(exception);
      }
      w1a() {
        return this.d1c_1.w1a();
      }
      *d1b(element, $completion) {
        yield* this.d1c_1.d1b(element, $completion);
        return Unit_instance;
      }
      e1b(element) {
        return this.d1c_1.e1b(element);
      }
      n1b(cause) {
        return this.d1c_1.n1b(cause);
      }
      *g1b($completion) {
        return yield* this.d1c_1.g1b($completion);
      }
      p1() {
        return this.d1c_1.p1();
      }
    }
    protoOf($).p1b = close$default;
    initMetadataForClass($, 'ChannelCoroutine', VOID, VOID, [SendChannel(), ReceiveChannel()], [1, 0]);
    ChannelCoroutineClass = $;
  }
  return ChannelCoroutineClass;
}
//region block: exports
export {
  ChannelCoroutine as ChannelCoroutine12l2gxei4u780,
};
//endregion

//# sourceMappingURL=ChannelCoroutine.mjs.map
